import React, { createContext, useContext } from "react";
import { useGoogleMapsApiKeyQuery } from "graphql/generated";

const GoogleMapsApiKeyContext = createContext<string | null | undefined>(undefined);

type Props = {
  children: React.ReactNode;
};

export const GoogleMapsApiKeyProvider: React.FC<Props> = ({ children }) => {
  const [result] = useGoogleMapsApiKeyQuery({
    requestPolicy: "cache-first",
  });

  const apiKey = result.data?.googleMapsApiKey ?? null;

  return <GoogleMapsApiKeyContext.Provider value={apiKey}>{children}</GoogleMapsApiKeyContext.Provider>;
};

export function useGoogleMapsApiKey(): string | null {
  const apiKey = useContext(GoogleMapsApiKeyContext);
  if (apiKey === undefined) {
    throw new Error("useGoogleMapsApiKey must be used within GoogleMapsApiKeyProvider");
  }
  return apiKey;
}
